// extracted by css-extract-rspack-plugin
export default {"removeLinkAnchor":"C7xiD","embedCodeContainer":"X9Zqz","copyButtonContainer":"TSg1x","embedCode":"ZdYZc"};